import {ApiConfig} from "@/directives/types";

const examBackUrl: string = process.env.VUE_APP_EXAM_API_URL || "";

const config: ApiConfig = {
  baseURL: `${examBackUrl}/admin`,
  endpoints: {
    unchecked: "/list/unchecked",
    passed: "/list/passed",
    failed: "/list/failed",
    all: "/list/all",
    check: "/check",
    delete: "/delete",
    saveEverCookie: "evercookie/save",
    removeEverCookie: "evercookie/remove",
    disableCheckingLocation: "location/disable",
    programmingLogs: "programming/logs",
  }
};

const urls = {
  signin: process.env.VUE_APP_SIGN_IN_URL,
  userProfile: process.env.VUE_APP_USER_PROFILE_ADMIN_URL
};

export default config;
export {urls};
